import { Button, Card, Column, Row, TextButton, Typography, CloseButton } from 'seagull';
import { LogoPicker } from "../../../components/LogoPicker/LogoPicker";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { useBrandingActions } from "../BrandingActionsContext";
import { PreviewState } from "../ClientOnboarding.utils";
import { useCobBranding } from "../CobBrandingContext";
import { useCobConfig } from "../CobConfigContext";
import styles from "./BrandingControllers.module.scss";
import { ColorsLabel, SectionTitle } from "./BrandingControllers.shared";
import { ColorSelectorWithPopup } from "./ColorSelectorWithPopup";
import { PrimaryBackgroundColorPopup } from "./PrimaryBackgroundColorPopup";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BrandingPanelV2() {
  const {
    branding,
    logoImage,
    errors,
    isDirty,
    isValid,
    setBranding,
    setLogo,
    revertToDefault,
    saveLogoAndBranding
  } = useCobBranding();
  const {
    SET_UP_BRAND_CLIENT_PREVIEW = false
  } = useFeatureFlags();
  const {
    originalPreviewState
  } = useCobConfig();
  const {
    onToggleBrandSetup
  } = useBrandingActions();
  function handleCloseClick() {
    onToggleBrandSetup();
  }
  return /*#__PURE__*/_jsxs(Card, {
    padding: "s",
    className: styles.brandingCardNew,
    children: [SET_UP_BRAND_CLIENT_PREVIEW ? /*#__PURE__*/_jsxs(Row, {
      alignItems: "center",
      justifyContent: "space-between",
      className: styles.headerRow,
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        variant: "paragraph1",
        children: 'Customize brand'
      }), originalPreviewState !== PreviewState.SetupBrand && /*#__PURE__*/_jsx(CloseButton, {
        skin: "standard",
        onClick: handleCloseClick,
        "data-testid": "close-branding-setup-btn"
      })]
    }) : /*#__PURE__*/_jsx(SectionTitle, {
      children: 'Upload logo'
    }), /*#__PURE__*/_jsxs(Column, {
      gap: 24,
      className: styles.scrollableContent,
      children: [/*#__PURE__*/_jsx(Column, {
        gap: 12,
        children: /*#__PURE__*/_jsx(LogoPicker, {
          isNewUI: true,
          testid: "upload-logo",
          image: logoImage,
          onChange: setLogo
        })
      }), /*#__PURE__*/_jsxs(Column, {
        gap: 24,
        children: [/*#__PURE__*/_jsxs(Row, {
          alignItems: "center",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsx(ColorsLabel, {
            children: "Brand color"
          }), /*#__PURE__*/_jsx(Row, {
            gap: 6,
            children: /*#__PURE__*/_jsx(ColorSelectorWithPopup, {
              branding: branding,
              hasError: errors.has('buttonPrimary'),
              colorKey: "buttonPrimary",
              onChange: setBranding
            })
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          alignItems: "center",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsx(ColorsLabel, {
            children: "Primary background"
          }), /*#__PURE__*/_jsx(Row, {
            gap: 6,
            children: /*#__PURE__*/_jsx(PrimaryBackgroundColorPopup, {
              branding: branding,
              hasError: errors.has('backgroundGradientStart') || errors.has('backgroundGradientEnd'),
              onChange: setBranding
            })
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          alignItems: "center",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsx(ColorsLabel, {
            children: "Secondary background"
          }), /*#__PURE__*/_jsx(Row, {
            gap: 6,
            children: /*#__PURE__*/_jsx(ColorSelectorWithPopup, {
              branding: branding,
              hasError: errors.has('backgroundStandard'),
              colorKey: "backgroundStandard",
              onChange: setBranding
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(Column, {
        gap: 12,
        alignItems: "center",
        className: styles.saveSection,
        children: [/*#__PURE__*/_jsx(Button, {
          skin: "primaryOutline",
          disabled: !isDirty || !isValid,
          "data-testid": "save-colors",
          tooltip: {
            placement: 'top',
            title: !isDirty ? 'Nothing to save' : !isValid ? 'One of the fields is invalid' : ''
          },
          onClick: saveLogoAndBranding,
          className: styles.saveBtn,
          children: "Save changes"
        }), /*#__PURE__*/_jsx(TextButton, {
          "data-testid": "undo-color-changes",
          variant: "paragraph2",
          skin: "primary",
          underline: "none",
          weight: "normal",
          onClick: revertToDefault,
          children: "Revert to default colors"
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph3",
          skin: "secondary",
          className: styles.disclaimer,
          children: "Changes saved here will apply to all of your proposals."
        })]
      })]
    })]
  });
}